/**
 * This function generates a random number between the given range.
 * @param min
 * @param max
 * @returns
 */
export function randomNumber(_min: number, _max: number, round = true) {
	const min = Math.min(_min, _max);
	const max = Math.max(_min, _max);
	if (round) return Math.floor(Math.random() * (max - min + 1)) + min;
	return Number((Math.random() * (max - min) + min).toFixed(2));
}
